import { Dialog } from '@material-ui/core'
import { useEffect, useState } from 'react'

export const PreviewFile = ({ base64, open, onClose }) => {
  const [urlBlob, setUrlBlob] = useState('')

  useEffect(() => {
    if (open && base64) {
      // for larger file should have to generate a blob url
      const binaryString = window.atob(base64)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)

      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      const blob = new Blob([bytes], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      setUrlBlob(url)
    }
  }, [open, base64])

  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      onClose={onClose}
      fullWidth={true}
      maxWidth="md"
      open={open}
    >
      <embed
        src={urlBlob}
        type="application/pdf"
        width="1000px"
        height="600px"
      />
    </Dialog>
  )
}

export default PreviewFile
